"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserInvitationResult = void 0;
var GuestUserInvitationResult;
(function (GuestUserInvitationResult) {
    GuestUserInvitationResult["alreadyInvited"] = "alreadyInvited";
    GuestUserInvitationResult["success"] = "success";
    GuestUserInvitationResult["notInvited"] = "notInvited";
})(GuestUserInvitationResult || (exports.GuestUserInvitationResult = GuestUserInvitationResult = {}));
//# sourceMappingURL=GuestUserInvitationResult.js.map